import { RoomType } from '@/shared/types';

export interface RoomLabel {
  /** The room's display name, or "Not specified" when it can't be resolved. */
  name: string;
  /** The typology grouping key, when the room belongs to one. */
  typologyKey?: string;
  /** The room's 1-based position within its typology (siblings ordered by creation). */
  unitNumber?: number;
}

/**
 * Resolve a room's display label. Units of a typology all share one `name`, so
 * the typology key and the unit's number within that typology are surfaced for a
 * precise, unambiguous label. Unit numbering matches the #N ordering AdminRooms
 * shows — siblings of the same (residenceId, typologyKey) sorted by creation time.
 */
export function getRoomLabel(
  roomTypeId: string | undefined,
  roomTypes: RoomType[],
): RoomLabel {
  const roomType = roomTypeId
    ? roomTypes.find((rt) => rt.id === roomTypeId)
    : undefined;
  const typologyKey = roomType?.typologyKey?.trim() || undefined;

  let unitNumber: number | undefined;
  if (roomType && typologyKey) {
    const units = roomTypes
      .filter(
        (rt) =>
          rt.residenceId === roomType.residenceId &&
          rt.typologyKey?.trim() === typologyKey,
      )
      .sort(
        (a, b) =>
          (a.createdAt?.toMillis?.() ?? 0) - (b.createdAt?.toMillis?.() ?? 0),
      );
    const index = units.findIndex((u) => u.id === roomType.id);
    if (index >= 0) unitNumber = index + 1;
  }

  return {
    name: roomType?.name || 'Not specified',
    typologyKey,
    unitNumber,
  };
}
